module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_10.cf7a3697.jpg";